'use strict';

exports.__esModule = true;

var _get = require('../utils/get');

var _updateByIdentifier = require('../tags/values/update-by-identifier');

var _ContextProps = require('../types/ContextProps');

var _Identifiers = require('../types/Identifiers');

var IDs = {
  SITE_NAME: 'site.name',
  INDEX_PAGE: 'page.index',
  IMAGE: 'product.image',
  IMAGE_WIDTH: 'product.imageWidth',
  IMAGE_HEIGHT: 'product.imageHeight',
  ID: 'product.id',
  NAME: 'product.name',
  DESCRIPTION: 'product.description',
  URL: 'product.url',
  TYPE: 'product.type',
  WEIGHT: 'product.weight',
  THUMBNAIL: 'product.thumbnail',
  AVAILABILITY: 'product.availability',
  SLUG: 'product.slug'
};

exports.default = {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    var available = (0, _get.getRawValue)(item, 'productOptionsAvailability.availableForPurchase');
    return _ref = {}, _ref[IDs.SITE_NAME] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.SITE_NAME), _ref[IDs.INDEX_PAGE] = (0, _get.getRawValue)(item, 'context.' + _ContextProps.CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.IMAGE] = (0, _get.get)(item, 'product.media.mainMedia.image.url'), _ref[IDs.IMAGE_WIDTH] = (0, _get.get)(item, 'product.media.mainMedia.image.width'), _ref[IDs.IMAGE_HEIGHT] = (0, _get.get)(item, 'product.media.mainMedia.image.height'), _ref[IDs.ID] = (0, _get.get)(item, 'product.id'), _ref[IDs.NAME] = (0, _get.get)(item, 'product.name'), _ref[IDs.DESCRIPTION] = (0, _get.get)(item, 'product.description'), _ref[IDs.URL] = (0, _get.get)(item, 'product.productPageUrl'), _ref[IDs.TYPE] = (0, _get.get)(item, 'product.productType'), _ref[IDs.WEIGHT] = (0, _get.get)(item, 'product.weight'), _ref[IDs.SLUG] = (0, _get.get)(item, 'product.slug'), _ref[IDs.THUMBNAIL] = (0, _get.get)(item, 'product.media.mainMedia.thumbnail.url'), _ref[IDs.AVAILABILITY] = available ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock', _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob(item) {
    var tags = (0, _updateByIdentifier.updateValueByIdentifier)([], _Identifiers.IDENTIFIERS.TITLE, (0, _get.get)(item, 'legacySeoData.title'));

    tags = (0, _updateByIdentifier.updateValueByIdentifier)(tags, _Identifiers.IDENTIFIERS.DESCRIPTION, (0, _get.get)(item, 'legacySeoData.description'));
    return { tags: tags };
  },
  getBiData: function getBiData(item) {
    return {
      id: (0, _get.get)(item, 'product.id'),
      name: (0, _get.get)(item, 'product.name')
    };
  },
  getKeys: function getKeys() {
    return Object.keys(IDs).map(function (id) {
      return { id: id };
    });
  }
};